module.exports = __webpack_public_path__ + "img/pine_light_ba_list.a6af1f3a.jpg";